import { AnalyticsEvent, TelemetryEvent, TelemetryEventType } from './types';

export const isAnalyticsEvent = (event: TelemetryEvent): event is AnalyticsEvent =>
  event.type === TelemetryEventType.Analytics;
